import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "titleDashboard" }
const _hoisted_2 = { class: "ml-4 titleDashboard" }

import { Ref,  onBeforeUnmount, onMounted, ref, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import NetworkChart from '@/components/SmartLink/maps/NetworkChart.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import KPICOMPONENT from '@/components/SmartLink/dashboard/KPI-Component.vue';
import VirtualMachines from '@/components/SmartLink/server - lte/VirMacDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { SystemStatus} from '@/interfaces/SmartLink/Equips';
import { TOPO_GENERAL,} from '@/interfaces/SmartLink/Topology';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllStatusData } from '@/services/Smartlink/Principal';
import { getIPServerData } from '@/services/Smartlink/Server';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/**
 * se obtiene el nombre del proyecto desde el store
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DashBoardView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
const projectName = computed(() => store.state.projectName);

/**
 * Intervalo de recarga de datos
 * Si es SmartLinkDEMO: 15 minutos (1/3)
 * Si es otro proyecto: 1 minutos (10/6)
 */
const INTERVALRECARGE = projectName.value === 'SmartLinkDEMO' ? (1/3) : (10/6)

/**
 * Valores del mapa Traídos de la API
 */
const statusEquips:Ref<TOPO_GENERAL[]>      = ref([]);  

/**
 * Objeto con la cantidad de estados según el subtipo
 */
const countEquipStatus:Ref<SystemStatus>    = ref({
    distri: { ok: 0, alarm: 0, alert: 0, down: 0},
    acceso: { ok: 0, alarm: 0, alert: 0, down: 0},
    client: { ok: 0, alarm: 0, alert: 0, down: 0},
});

/**
 * Muestra El componente de Network (Mapa) si desde la API
 * traen información
 */
const showNetWork   = ref(true);

/**
 * Muestra El componente de KPI si desde la API
 * traen información
 */
const showKPI       = ref(false);  


/**
 * Captura toda la info de la API: "getAllTopologyData"
 * lo almacena en la variable "statusEquips".
 * Calcula la cantidad de equipos en según que estados,
 * filtrando por su familia, lo almacena en "countEquipStatus"
 */
async function getStatusData(){

    const allData = await getAllStatusData()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        countEquipStatus.value = allData.data.countEquipData
        statusEquips.value = allData.data.statusEquipData
    }
    showKPI.value = allData.showGraphs
    // showNetWork.value = allData.showGraphs
}

/**
 * Para recargar el Componente KPI
 */
const changeKPIData = ref(true);

/**
 * Para recargar el Componente Virtual Machine
 */
const changeMVSData = ref(true);

/**
 * Valor numérico del ciclo 
 */
const valorCount = ref(0);

/**
 * Valor final del INVERVALOR para el reset de la data
 */
const interval = ref();

/**
 * Se activa cada 15 minutos (1 minuto si no es DEMO) o cuando le das click al círculo en la parte superior derecha del mapa.
 * Recarga la infomación de los componentes hijos. (KPI y Virtual Machine)
 */
async function restarInfo(){
    
    changeKPIData.value = false;
    changeMVSData.value = false;
    showKPI.value = false;
    // showNetWork.value = false;
    valorCount.value    = 0;

    statusEquips.value  = [];
        
    getStatusData();
    getIpVirMac();

    // Hay un delay de 100ms para la carga de data
    setTimeout(()=> {
        changeKPIData.value = true;
        changeMVSData.value = true;
        showKPI.value = true;
        showNetWork.value = true;

    },100)
}


/**
 * Muestra El componente de Virtual Machine si desde la API
 * traen información
 */
const showVirMac    = ref(true);

/**
 * Array de IP de los servidores
 */
const ipVIRMAC:Ref<string[]> =    ref([])

/**
 * Consulta la API: "getIPServer"
 * Captura las IPs de los equipos de TIPO: SERVIDOR/SERVER
 * lo almacena en el ARRAY: "ipVIRMAC"
 */
async function getIpVirMac() { 

    const allData = await getIPServerData()

    showVirMac.value = allData.showGraphs
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        ipVIRMAC.value = allData.data
    }
}

/**
 * Cuando se desmonta el componente (cuando le das a otra vista)
 * se reinicia el intervalo
 */
onBeforeUnmount(() => {
    clearInterval(interval.value)
}),

onMounted( async() => {
    
    getStatusData();   
    getIpVirMac();       

    /**
     * Crea un intervalo que dura 1 minuto
     * Cuando llega a 1 minuto, llama a la función "restarInfo()"
     * (15 minutos cuando se trata de SmartLinkDEMO)
     */
    interval.value = setInterval(async()=>{
        if(valorCount.value > 100 ){ 
            await restarInfo(); 
        }
        valorCount.value += INTERVALRECARGE;
    },1000)
})


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (projectName.value !== 'SmartLinkRAOS')
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "pa-0",
              cols: "12",
              sm: "12",
              md: "12",
              lg: "12",
              xl: "12",
              xxl: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "ma-4 pa-4 mb-0 mt-0 py-0",
                  style: {"border-radius":"10px"},
                  elevation: "0",
                  color: "bgtopology"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          justify: "space-between",
                          class: "ma-0",
                          style: {"align-items":"center"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('labels.linkMap')), 1),
                            _createVNode(_component_v_progress_circular, {
                              class: "circular_btn",
                              rotate: 360,
                              size: 25,
                              width: 5,
                              "model-value": valorCount.value,
                              color: "bgCircular",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (restarInfo()))
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, {
                      class: _normalizeClass(["pr-0", statusEquips.value.length > 0 ? '' : 'text-center'])
                    }, {
                      default: _withCtx(() => [
                        (showNetWork.value)
                          ? (_openBlock(), _createBlock(NetworkChart, { key: 0 }))
                          : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showKPI.value)
              ? (_openBlock(), _createBlock(KPICOMPONENT, {
                  key: 0,
                  recharge: changeKPIData.value,
                  countEquipStatus: countEquipStatus.value
                }, null, 8, ["recharge", "countEquipStatus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "ma-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "pa-0"
        }, {
          default: _withCtx(() => [
            (showVirMac.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  class: "defaultCard",
                  color: "bgtopology"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('sidebar.servers')), 1),
                    (ipVIRMAC.value.length > 0)
                      ? (_openBlock(), _createBlock(VirtualMachines, {
                          key: 0,
                          ip: ipVIRMAC.value,
                          recharge: changeMVSData.value,
                          emited: false,
                          rows: 7
                        }, null, 8, ["ip", "recharge"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})